import { render, staticRenderFns } from "./doorEvent.vue?vue&type=template&id=6604481e&scoped=true"
import script from "./doorEvent.vue?vue&type=script&lang=js"
export * from "./doorEvent.vue?vue&type=script&lang=js"
import style0 from "./doorEvent.vue?vue&type=style&index=0&id=6604481e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6604481e",
  null
  
)

export default component.exports